import React from 'react';
import { STATUS, statusesNames } from '../../constants/filters';
import StatusCell from '../StatusCell/StatusCell';
import formatDate from './formatDate';

export default function prepareAdviceRows(rawData) {
  return rawData.map((advice) => {
    const solutionText = advice.cases?.find((c) => c.caseNumber === advice.solutionVariantNumber)?.caseText || '-';
    const solutionDescription =
      advice.status === STATUS.SOLVED || advice.status === STATUS.INPROGRESS
        ? solutionText
        : advice.solutionDescription || '–';

    const isModifiedByUser = advice.lastModifiedBy?.toLowerCase() !== 'system' && advice.status === STATUS.SOLVED;

    return {
      ...advice,
      priority: <StatusCell priority={advice.priority} />,
      status: statusesNames[advice.status],
      createdDate: advice?.createdDate ? formatDate(new Date(advice.createdDate)) : '–',
      endTime: advice?.endTime ? formatDate(new Date(advice.endTime)) : '–',
      solutionDescription,
      lastModifiedDate:
        advice?.lastModifiedDate && isModifiedByUser ? formatDate(new Date(advice.lastModifiedDate)) : '–',
      lastModifiedBy: isModifiedByUser ? advice.lastModifiedBy : '–',
      item: { adviceId: advice.logisticAdvicesId, cases: advice.cases },
    };
  });
}
